import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { SearchFilterRegionRequest } from "@/main/models/request";
import { DistributionRegionResponse } from "@/main/models/response";
import FilterRegionScreenWrapper from "@/main/screens/registration/region/filterRegionScreen/filterRegionScreen";
import GridRegionScreen from "@/main/screens/registration/region/gridRegionScreen/gridRegionScreen";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { useState } from "react";

function RegionScreen(){
     const titlePage = `${getTranslateByKey(
        'information.registration'
      )} > ${getTranslateByKey('information.searchRegion')}`;

      const [dataGrid, setDataGrid] = useState<DistributionRegionResponse[]>([])
      const [
          formFilters,
          setFormFilters
        ] = useState<SearchFilterRegionRequest | null>(null);

      function onResetSearch(){
        setDataGrid([]);
        setFormFilters(null)
      }

      function getDataRegion(
        filters: SearchFilterRegionRequest | Partial<SearchFilterRegionRequest>,
        isResetSearch: boolean = true
    ) {
        const request: SearchFilterRegionRequest | null = {
            ...(isResetSearch ? {} : formFilters),
            ...(filters as SearchFilterRegionRequest),
            pageIndex: PaginationEnum.PageIndexIntial,
            pageSize: PaginationEnum.PageSize30
        };

        onResetSearch();
        setFormFilters(request);
      }

    return (
        <ContainerScreen title={titlePage}>
            <FilterRegionScreenWrapper
                onResetSearch={onResetSearch} 
              formFilters={formFilters}
                getDataRegion={getDataRegion}/>

            <GridRegionScreen 
                datagrid={dataGrid}
                formFilters={formFilters}
                setDataGrid={setDataGrid}
                setFormFilters={setFormFilters}/>
        </ContainerScreen>
    );
}

export default withQueryparams(RegionScreen);